import React, { ReactNode } from "react";
import { useAppSelector } from "../../redux/hooks/hooks";
import { selectProtectionType, selectUserFunctions } from "../../redux/feature/settings/configurations-slice";
import { UserFunction } from "../../api/models/user-function";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { DISABLED } from "../../utils/user-function/userFunctionUtils";
import { OperationCompletedPanel } from "../layout/OperationCompletedPanel";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

interface ProtectedComponentInterface {
  children: ReactNode;
  userFunction?: UserFunctionEnum;
  errorComponent?: ReactNode;
  protectionType?: boolean;
  isAuthorizedOverride?: (p: { originalAuthorization: boolean }) => boolean;
}

export const ProtectedComponent: React.FunctionComponent<ProtectedComponentInterface> = (props) => {
  const userFunctions: UserFunction[] = useAppSelector(selectUserFunctions);
  const protectionType: number = useAppSelector(selectProtectionType);
  const userFunction = props.userFunction;
  let isReadOnly: boolean;
  const userFunctionsEnum: UserFunctionEnum[] = [];
  userFunctionsEnum.push(UserFunctionEnum.MENU_NEW_DOCUMENT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_IMPORT_DOCUMENT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_NEW_OBJECT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_EDIT_OBJECT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_MOVE_OBJECT);
  userFunctionsEnum.push(UserFunctionEnum.MENU_OBJECT_LIST);
  userFunctionsEnum.push(UserFunctionEnum.MENU_DOCUMENT_OUTLINE);
  userFunctionsEnum.push(UserFunctionEnum.MENU_DOCUMENT_LIBRARY);
  userFunctionsEnum.push(UserFunctionEnum.MENU_UPDATE_PANEL_GET_CHANGES);

  let userFunctionsMap = new Map<string, boolean>();
  userFunctionsEnum.forEach((value) => userFunctionsMap.set(value.toString(), false));
  if (userFunctions) {
    userFunctions.forEach((func: UserFunction) => {
      if (func.action !== DISABLED) {
        userFunctionsMap.set(func.function, true);
      }
    });
  }
  if (props.protectionType && protectionType === 3) {
    isReadOnly = true;
  }
  if (isReadOnly && (userFunction ? userFunctionsMap.get(userFunction?.toString()) : true)) {
    return (
      <OperationCompletedPanel
        message={formatMessage("cof.access.message.error.readonly")}
        alt={formatMessage("cof.access.message.error.readonly")}
        icon="/assets/Unauthorized.svg"
        styles={{ container: { minHeight: "70vh" } }}
      />
    );
  }

  let isValid = !userFunction || userFunctionsMap.get(userFunction?.toString());
  if (props.isAuthorizedOverride) isValid = props.isAuthorizedOverride({ originalAuthorization: isValid });

  if (isValid) return <>{props.children}</>;
  return <>{props.errorComponent}</>;
};
